export default "__VITE_ASSET__gCO6kGAz__"